<template>
  <q-form ref="formRef" greedy>
    <div class="text-h5 text-bold">イメージ</div>
    <div class="text-subtitle2">イメージのスタイル設定</div>
    <div class="row q-mt-md">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>タイプ<span class="text-brand-red">*</span></div>
        <div class="text-caption">Type</div>
      </div>
      <q-select outlined dense emit-value map-options v-model="value.type" :options="typeList" class="col" disable>
        <template v-slot:selected-item="scope">
          <div class="column">
            <div>{{ scope.opt.label }}</div>
            <div class="text-caption">{{ scope.opt.value }}</div>
          </div>
        </template>
      </q-select>
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>フレックス</div>
        <div class="text-caption">Flex</div>
      </div>
      <q-input outlined dense type="number" min="0" v-model.number="value.flex" placeholder="Num." class="col" />
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>ポジション</div>
        <div class="text-caption">position</div>
      </div>
      <q-select outlined dense v-model="value.position" :options="['', 'relative', 'absolute']" class="col" />
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>画像URL</div>
        <div class="text-caption">url</div>
      </div>
      <MediaInput
        v-model="value.url"
        :maxSize="value.animated ? 300 / 1024 : 10"
        :fileFormat="['.jpeg', '.png', '.jpg']"
        :maxWidth="1024"
        :maxHeight="1024"
        :placeHolder="'https_url_to_image'"
      />
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>マージン</div>
        <div class="text-caption">margin</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.margin"
        :rules="[(val) => marginValidate(val) || 'invalid property']"
        placeholder="XXpx"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-btn-dropdown no-caps unelevated color="brand-grey" label="px or keywords">
            <q-list>
              <q-item
                v-for="(item, index) in marginList"
                clickable
                v-close-popup
                :key="index"
                @click="value.margin = item"
              >
                <q-item-section>
                  <q-item-label>{{ item }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </template>
      </q-input>
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>行揃え</div>
        <div class="text-caption">align</div>
      </div>
      <q-select outlined dense v-model="value.align" :options="['', 'start', 'end', 'center']" class="col" />
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>垂直位置</div>
        <div class="text-caption">gravity</div>
      </div>
      <q-select outlined dense v-model="value.gravity" :options="['', 'top', 'bottom', 'center']" class="col" />
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>サイズ</div>
        <div class="text-caption">size</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.size"
        placeholder="XXpx"
        :rules="[(val) => sizeValidate(val) || 'invalid property']"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-btn-dropdown no-caps unelevated color="brand-grey" label="px, % or keywords">
            <q-list>
              <q-item v-for="(item, index) in sizeList" clickable v-close-popup :key="index" @click="value.size = item">
                <q-item-section>
                  <q-item-label>{{ item }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </template>
      </q-input>
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>アスペクト比</div>
        <div class="text-caption">aspectRatio</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.aspectRatio"
        :rules="[(val) => aspectRatioValidate(val) || 'invalid property']"
        placholder="Text"
        class="col"
      />
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>アスペクトモード</div>
        <div class="text-caption">aspectMode</div>
      </div>
      <q-select outlined dense v-model="value.aspectMode" :options="['', 'cover', 'fit']" class="col" />
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>背景色</div>
        <div class="text-caption">backgroundColor</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.backgroundColor"
        :rules="[(val) => colorValidate(val) || 'invalid property']"
        placeholder="#FFFFFF"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-icon name="colorize" class="cursor-pointer">
            <q-popup-proxy cover transition-show="scale" transition-hide="scale">
              <q-color no-header no-footer v-model="value.backgroundColor" />
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>アニメーション</div>
        <div class="text-caption">animated</div>
      </div>
      <q-select outlined dense emit-value map-options v-model="value.animated" :options="trueFalseList" class="col" />
    </div>
    <q-separator class="q-my-md" v-if="isAdmin" />
    <Offset v-model="value" v-if="isAdmin" />
    <q-separator class="q-my-md" v-if="isAdmin" />
    <Action v-model="value.action" :isAdmin="isAdmin" v-if="isAdmin" />
  </q-form>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageImage, IFlexMessageURIAction } from '@/utils/types'
import Offset from '@/components/common/flex-message/forms/Offset.vue'
import Action from '@/components/common/flex-message/forms/Action.vue'
import MediaInput from '@/components/common/ui/MediaInput.vue'

@Options({
  components: { MediaInput, Action, Offset },
  directives: { maska },
  emits: ['update:modelValue', 'update:validateValue'],
})
export default class Image extends Vue {
  @Prop()
  modelValue!: IFlexMessageImage

  @Prop()
  isAdmin!: boolean

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageImage) {
    this.$emit('update:modelValue', value)
  }

  get typeList() {
    return [
      {
        label: 'イメージ',
        value: 'image',
      },
    ]
  }

  get marginList() {
    return ['none', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']
  }

  get sizeList() {
    return ['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl', '3xl', '4xl', '5xl', 'full']
  }

  get trueFalseList() {
    return [
      {
        label: '',
        value: '',
      },
      {
        label: 'True',
        value: true,
      },
      {
        label: 'False',
        value: false,
      },
    ]
  }

  get validateRule() {
    return {
      url: this.$t('validate.url_validation'),
    }
  }

  aspectRatioValidate(val) {
    if (!val) return true

    const match = /^(\d{1,5}(?:\.\d+)?):(\d{1,5}(?:\.\d+)?)$/.exec(val)
    if (!match) return false

    const width = parseFloat(match[1])
    const height = parseFloat(match[2])

    if (width < 1 || width > 100000 || height < 1 || height > 100000) {
      return false
    }

    return height <= width * 3
  }

  colorValidate(val) {
    if (!val) return true
    return /^#[0-9A-Fa-f]{6}([0-9A-Fa-f]{2})?$/.test(val)
  }

  marginValidate(val) {
    if (!val) return true

    const isPx = /^\d+(\.\d+)?px$/.test(val)
    const isKeyword = this.marginList.includes(val)
    return !(!isPx && !isKeyword)
  }

  sizeValidate(val) {
    if (!val) return true

    const isPxOrPercent = /^(\d+(\.\d+)?)(px|%)$/.test(val)
    const isKeyword = this.sizeList.includes(val)
    return !(!isPxOrPercent && !isKeyword)
  }

  urlValidate(val) {
    const urlPattern = new RegExp(
      '^(https?:\\/\\/)?' +
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
      '((\\d{1,3}\\.){3}\\d{1,3}))' +
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
      '(\\?[;&a-z\\d%_.~+=-]*)?' +
      '(\\#[-a-z\\d_]*)?$',
      'i'
    )
    return urlPattern.test(val)
  }

  @Watch('value', { deep: true })
  async validate() {
    await this.$nextTick(async () => {
      const isValid = await this.$refs.formRef.validate()
      if (isValid) {
        this.$emit('update:validateValue', true)
      } else {
        this.$emit('update:validateValue', false)
      }
      return isValid
    })
  }

  mounted() {
    this.validate()
  }
}
</script>

<style scoped lang="scss">
</style>
